import CloseIcon from '@mui/icons-material/Close'
import {
  Button,
  Collapse,
  createTheme,
  ThemeProvider,
  Toolbar,
} from '@mui/material'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { jaJP } from '@mui/material/locale'
import { SnackbarKey, SnackbarProvider } from 'notistack'
import React from 'react'
import GlobalDialog from './Dialogs'
import AppHeader from './Header'
import ScrollToTop from './ScrollToTop'
import SocketIO from './Socket'

interface Props {
  window?: () => Window
  children: React.ReactElement
}

const globalTheme = createTheme(
  {
    palette: {
      primary: {
        main: '#00bfa5',
        light: '#5df2d6',
        dark: '#008e76',
        contrastText: '#fff',
      },
      secondary: {
        main: '#d50000',
        light: '#ff5131',
        dark: '#9b0000',
        contrastText: '#fff',
      },
    },
    typography: {},
    components: {
      MuiInputBase: {
        styleOverrides: {},
      },
    },
  },
  jaJP
)

export default function Layout(props: Props) {
  const notistackRef = React.createRef<any>()
  const closeSnackbar = (key: SnackbarKey) => () => {
    notistackRef.current.closeSnackbar(key)
  }

  return (
    <ThemeProvider theme={globalTheme}>
      <SnackbarProvider
        dense
        id="notistackGlobal"
        ref={notistackRef}
        maxSnack={5}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        style={{
          flexWrap: 'nowrap',
        }}
        autoHideDuration={5000}
        preventDuplicate
        TransitionComponent={Collapse as any}
        action={(snackbarId) => (
          <Button
            onClick={closeSnackbar(snackbarId)}
            sx={{
              color: (theme) => theme.palette.primary.contrastText,
              marginLeft: '-1px',
              minWidth: 'auto',
            }}
          >
            <CloseIcon sx={{ color: '#fff' }} />
          </Button>
        )}
      >
        <GlobalDialog />
        <SocketIO />
        <AppHeader {...props} />
        <Box
          component="main"
          sx={{
            bgcolor: 'background.default',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Toolbar id="top" />
          <Container
            sx={{
              color: (theme) => (theme.palette.mode === 'dark' ? '#fff' : ''),
              flex: 1,
              pb: 4,
            }}
          >
            {props.children}
          </Container>
        </Box>
        <ScrollToTop />
      </SnackbarProvider>
    </ThemeProvider>
  )
}
